document.addEventListener('DOMContentLoaded', () => {
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (let cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) {
                return value;
            }
        }
        return null; // Return null if the cookie is not found
    }

    const cookieAccept = document.querySelector("#cookie-accept");
    if (cookieAccept) {
        cookieAccept.addEventListener("click", function () {
            document.cookie = "marketing=1; expires=" + new Date(Date.now() + 34560000 * 1000).toUTCString() + "; path=/; domain=ipromote.com";
            const cookieBanner = document.querySelector('.cookie-banner');
            if (cookieBanner) {
                cookieBanner.style.display = 'none';
            }
        });
    }

    const cookieRejectAll = document.querySelector("#cookie-reject-all");
    if (cookieRejectAll) {
        cookieRejectAll.addEventListener("click", function () {
            document.cookie = "marketing=1; expires=" + new Date(Date.now() + 34560000 * 1000).toUTCString() + "; path=/; domain=ipromote.com";
            window.location.replace(`https://servedby.ipromote.com/ad/?typ=16&redir=${encodeURIComponent(window.location.href)}`);
        });
    }

    // To prevent the success pages for the opt in/out from showing the popup on refresh
    if (window.location.href.includes("?success=true")) {
        setTimeout(function () {
            window.history.pushState({}, document.title, window.location.pathname);
        }, 10);
    }

    const marketingCookie = getCookie('marketing');
    if (marketingCookie !== '1') {
        // Hide the element with the class "cookie-banner"
        const cookieBanner = document.querySelector('.cookie-banner');
        if (cookieBanner) {
            cookieBanner.style.display = 'block';
        }
    }
});